<template>
  <div class="d-flex flex-wrap align-center">
    <div class="d-none d-sm-flex d-sm-none d-md-flex">
      <v-avatar tile size="125">
        <img class="header-logo" src="../../assets/logo.webp"
             alt="Logo"/>
      </v-avatar>
    </div>
    <div class="align-self-end text-left">
      <h4 style="color:#000000;">AGND+</h4>
      <h1 style="color:#008AFC;">Agenda Plus</h1>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tw-logo-sistema',
};
</script>
